import React from "react"
import { Flex, Box } from "@theme-ui/components"

export default ({ sx, ...props }) => (
  <Flex sx={{ flexDirection: "column", ...sx }} {...props}>
    <Box sx={{ mb: 1, height: "1px", bg: "#BFBFB8" }} />
    <Box sx={{ height: "2px", bg: "#BFBFB8" }} />
  </Flex>
)
